export const baseUrl = process.env.REACT_APP_BASE_URL;
export const corporateUrl = process.env.REACT_APP_CORPORATE_URL ;

export default baseUrl;
